<app-base-template (modal)="openModal(content)" (searchmodal)="searchModal()" (dataExportToExcel)="exportToExcel()"
  (tabledata)="getTableData()" [displayData]="displayData" [nextOffset]="nextOffset" [previousOffset]="previousOffset"
  (offset)="getData($event)" (resetData)="reset()" [showResetBtn]="showResetBtn" (pageSize)="onPageSizeChange($event)"
  [pageNo]="page_no" [showSearch]="showSearch" [showExportBtn]="showExportBtn" [totalPage]="totalPage"
  [dataLoaded]="dataLoaded"></app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Maintain Ticket Category / Priority</div>
    <div class="loader" [hidden]="dataLoaded"><img class="loading-gif" src="../../../assets/img/loader.gif"></div>
  </div>
  <mat-tab-group mat-align-tabs="center" [selectedIndex]='selectedIndextab' (selectedTabChange)="tabClick()">

    <mat-tab label="Add Category">
      <div class="modal-body">
        <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>

        <div class="form-group">
          <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="ticketSelected"
            (change)="onTicketChange($event.target.selectedIndex)">
            <option *ngFor="let ticket of tickets" [value]="ticket.id">{{ticket.name}}</option>
          </select>
        </div>
        <div class="form-group">
          <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="areaSelected"
            (change)="onAreaChange($event.target.selectedIndex)">
            <option *ngFor="let area of areas" [value]="area.id">{{area.name}}</option>
          </select>
        </div>

        <div class="form-group" *ngIf="seq > 1">
          <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="areaSelected1"
            (change)="onAreaChange1($event.target.selectedIndex)">
            <option *ngFor="let area of areas1" [value]="area.id">{{area.name}}</option>
          </select>
        </div>


        <div class="form-group" *ngIf="seq > 1">
          <!-- <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="parentSelected"
                      (change)="onParentChange($event.target.selectedIndex)">
                <option *ngFor="let parent of parents" [value]="parent.id">{{parent.name}}</option>
              </select> -->
          <mat-form-field style="width: 100%;">
            <mat-label class="font-13">Select Parent Category</mat-label>
            <mat-select [(ngModel)]="parentSelected"  (selectionChange)="onParentChange()">
              <mat-option *ngFor="let parent of parents" [value]="parent.id" style="height: fit-content;"><small>
                  {{parent.name}}
                </small></mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="form-group">
          <div class="form-group">
            <input type="text" class="form-control radius-0 font-13" [(ngModel)]="attrVal" placeholder="Enter value">
          </div>
        </div>
        <div class="form-group">
          <div class="form-group">
            <input type="text" class="form-control radius-0 font-13" [(ngModel)]="attrDesc"
              placeholder="Enter Description">
          </div>
        </div>
        <div class="form-group" *ngIf="isShow">
          <mat-checkbox [(ngModel)]="attachClaimNo">Attach Claim No:</mat-checkbox>
        </div>
      </div>
      <div class="modal-footer pad-8">
        <button type="button" class="btn btn-success radius-0" (click)="save()">Save</button>
        <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
      </div>
    </mat-tab>
    <mat-tab label="Map Priority to Ticket Category">

      <div class="modal-body">
        <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
        <div class="form-group">
          <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="ticketSelected"
            (change)="onTicketChange1($event.target.selectedIndex)">
            <option *ngFor="let ticket of tickets" [value]="ticket.id">{{ticket.name}}</option>
          </select>
        </div>
        <div class="form-group" *ngIf="priorityType===1">
          <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="impactSelected"
            (change)="onImpactChange($event.target.selectedIndex)">
            <option *ngFor="let impact of impacts" [value]="impact.id">{{impact.name}}</option>
          </select>
        </div>
        <div class="form-group" *ngIf="priorityType===1">
          <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="urgencySelected"
            (change)="onUrgencyChange($event.target.selectedIndex)">
            <option *ngFor="let urgency of urgencies" [value]="urgency.id">{{urgency.name}}</option>
          </select>
        </div>
        <div class="form-group" *ngIf="priorityType===2">
          <!-- <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="categorySelected"
            (change)="onCategoryChange($event.target.selectedIndex)">
            <option *ngFor="let category of categories" [value]="category.id">{{category.name}}</option>
          </select> -->

          <mat-form-field style="width: 100%;" >
            <mat-label class="font-13">Select Parent Category</mat-label>
            <mat-select [(ngModel)]="categorySelected" (selectionChange)="onCategoryChange()">
              <mat-option *ngFor="let category of categories" [value]="category.id" style="height: fit-content;"><small>
                  {{category.name}}
                </small></mat-option>
            </mat-select>
          </mat-form-field>

        </div>
        <div class="form-group">
          <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="prioritySelected"
            (change)="onPriorityChange($event.target.selectedIndex)">
            <option *ngFor="let priority of priorities" [value]="priority.id">{{priority.name}}</option>
          </select>
        </div>

      </div>
      <div class="modal-footer pad-8">
        <button type="button" class="btn btn-success radius-0" (click)="saveMatrix()">Save</button>
        <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
      </div>
    </mat-tab>
  </mat-tab-group>

</ng-template>



<ng-template #scarch_content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Search</div>
  </div>
  <div class="modal-body">
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="ticketSelected"
        (change)="onTicketChange($event.target.selectedIndex)">
        <option *ngFor="let ticket of tickets" [value]="ticket.id">{{ticket.name}}</option>
      </select>
    </div>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="icSelected">
        <option *ngFor="let ic of ics" [value]="ic.id">{{ic.name}}</option>
      </select>
    </div>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="levelSelected">
        <option *ngFor="let level of levels" [value]="level.id">{{level.name}}</option>
      </select>
    </div>
    <div class="form-group mar_top">
      <input type="text" class="form-control radius-0 font-13" placeholder=" Enter Category Name "
        [(ngModel)]="categoryName">
    </div>
  </div>
  <div class="modal-footer pad-8">
    <div class="form-group mar-bot-10" *ngIf="isSearch">
      <img class="loading-gif-42" src="../../../assets/img/loader-42px.gif">
    </div>
    <button type="button" class="btn btn-success float-right radius-0" (click)="search()">search</button>
    <button type="button" class="btn btn-primary radius-0" (click)="resetSearch()">Reset</button>
    <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>
</ng-template>

<notifier-container></notifier-container>